import React, { useState } from "react";
import Link from "next/link";

function Header() {
  const [showNav, setShowNav] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(true);
  /*  const [subLinks, setSubLinks] = useState("none"); */
  let display = false;
  let mobilenav = false;

  function showMobileNav() {
    document.getElementById("menu-bar").classList.toggle("change");
    var nav = document.getElementById("navigtion-mobile");
    if (mobilenav == false) {
      nav.classList.remove("dd-none");
      mobilenav = true;
    } else {
      nav.classList.add("dd-none");
      mobilenav = false;
    }
  }

  function toggleDropdown() {
    var dropdown = document.getElementById("header-dropdown1");
    if (display == false) {
      dropdown.classList.remove("d-none");
      dropdown.style.transition = "max-height";
      dropdown.style.transition = "0.5s ease-in-out";
      display = true;
    } else {
      dropdown.classList.add("d-none");
      dropdown.style.transition = "0.5s ease-in-out";
      display = false;
    }
  }

  function toggleDropdown2() {
    var dropdown = document.getElementById("header-dropdown2");
    if (display == false) {
      dropdown.classList.remove("d-none");
      display = true;
    } else {
      dropdown.classList.add("d-none");
      display = false;
    }
  }

  function toggleDropdown3() {
    var dropdown = document.getElementById("header-dropdown3");
    if (display == false) {
      dropdown.classList.remove("d-none");
      display = true;
    } else {
      dropdown.classList.add("d-none");
      display = false;
    }
  }

  /*   function menuOnClick() {
      if (typeof document !== 'undefined') {
        document.getElementById('menu-bar').classList.toggle('change');
        if (hideDesktop) {
          document.getElementById('links-wrap').classList.remove('hide-desktop');
          setHideDesktop(false);
        } else {
          document.getElementById('links-wrap').classList.add('hide-desktop');
          setHideDesktop(true);
        }
      }
    } */

  const tt = () => {
    setSubLinks("flex");
  };

  function showSubLinks() {
    const subLinkBox = document.getElementById("subLinkBox");

    if (subLinkBox.style.height === "0px") {
      subLinkBox.style.height = subLinkBox.scrollHeight + "px";
    } else {
      subLinkBox.style.height = "0px";
    }
    console.log("sublinks")
  }

  function showSubLinksMobile() {
    const subLinkBoxMobile = document.getElementById("subLinkBoxMobile");

    if (subLinkBoxMobile.style.height === "0px") {
      subLinkBoxMobile.style.height = subLinkBoxMobile.scrollHeight + "px";
    } else {
      subLinkBoxMobile.style.height = "0px";
    }
    console.log("sublinks")
  }

  return (
    <div className="header-outer-wrap wrap-header">
      <div className="header-wrap flex justify-between items-center">
        <div>
          <Link href="/" >
            <img
              className="header-logo"
              src="/src/EG_2024_Logo_Rund.png"
              alt="header-logo"
            />
          </Link>
        </div>

        {/* <div className='hamburger-menu-icon' onClick={() => setShowNav(!showNav)}>
        &#9776;
      </div> */}
        <nav role="navigation" className="primary-navigation">
          <ul className="hide-desktop">
            <li>
              <Link className="dropdown-text flex text-up" href="/marken-und-biere">
                  MARKEN & BIERE{" "}
              </Link>
              <ul className="header-dropdown1">
                <li>
                  <Link className="px-2" href="/hacker-pschorr">
                    Hacker-Pschorr
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/paulaner">
                    Paulaner
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/fuerstenberg">
                   Fürstenberg
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/auerbraeu">
                    Auerbräu
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/chiemseer">
                    Chiemseer
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/schmucker">
                    Schmucker
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/hoepfner">
                   Hoepfner
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link
                className="dropdown-text flex ml-4"
                href="/service-und-seminare"
                >
                  SERVICE & SEMINARE{" "}
              </Link>
              <ul className="header-dropdown">
                <li>
                  <Link className="px-2" href="/ansprechpartner">
                    Ansprechpartner
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/unsere-seminare">
                    Seminare
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/gastronomieforum">
                    Gastronomieforum
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/stern-der-gastlichkeit">
                    Stern der Gastlichkeit
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/pachtboerse">
                    Pachtbörse
                  </Link>
                </li>
                <li onClick={showSubLinks}>
                  <a className="px-2">Mediendatenbank</a>
                  <div
                    className="sublinks-box"
                    style={{ height: "0px" }}
                    id="subLinkBox"
                  >
                    <a
                      target="_blank"
                      href="https://www.pbg-mediendatenbank.de/hacker-de/de/login"
                      className="px-2 sub-link"
                    >
                      Hacker-Pschorr
                    </a>
                    <a
                      target="_blank"
                      href="https://www.pbg-mediendatenbank.de/paulaner-de/de/login"
                      className="px-2 sub-link"
                    >
                      Paulaner
                    </a>
                    <a
                      target="_blank"
                      href="https://www.pbg-mediendatenbank.de/chiemseer/de/login"
                      className="px-2 sub-link"
                    >
                      Chiemseer
                    </a>
                    <a
                      target="_blank"
                      href="https://www.pbg-mediendatenbank.de/hoepfner/de/login"
                      className="px-2 sub-link"
                    >
                      Hoepfner
                    </a>
                    <a
                      target="_blank"
                      href="https://www.pbg-mediendatenbank.de/schmucker/de/login"
                      className="px-2 sub-link"
                    >
                      Schmucker
                    </a>
                    <a
                      target="_blank"
                      href="https://www.pbg-mediendatenbank.de/fuerstenberg-de/de/login"
                      className="px-2 sub-link"
                    >
                      Fürstenberg
                    </a>
                    <a
                      target="_blank"
                      href="https://www.pbg-mediendatenbank.de/bilger-stuemple/de/login"
                      className="px-2 sub-link"
                    >
                      Bilger Stümple
                    </a>
                    <a
                      target="_blank"
                      href="https://www.pbg-mediendatenbank.de/riegeler/de/login"
                      className="px-2 sub-link"
                    >
                     Riegeler
                    </a>
                  </div>
                </li>
                <li>
                  <Link
                    href="https://posmaterial.paulaner.de/de_DE#/?_k=scfkob"
                    target="_blank"
                    className="px-2">
                    Werbemittelkonfigurator
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link className="dropdown-text flex ml-4" href="/schanktechnik-und-bierpflege">
                  SCHANKTECHNIK & BIERPFLEGE
              </Link>
              <ul className="header-dropdown">
                <li>
                  <Link className="px-2" href="/bierpflege">
                      Bierpflege
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/schanktechnik">
                      Schanktechnik
                  </Link>
                </li>
                <li>
                  <Link className="px-2" href="/schankdruckrechner">
                  Schankdruckrechner
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>

       {/*  <div className="header-contact hide-desktop">
          <a href="mailto:erfolgreichgastro@paulaner-gruppe.de  ?subject=Bitte um Rückruf &body=Sehr geehrte Damen und Herren,%0D%0A%0D%0A ich bitte um einen Rückruf.%0D%0A Meine Telefonnummer ist:%0D%0A%0D%0A Mit freundlichen Grüßen">
            <img src="/src/phone.png" alt="phone-logo"></img>
          </a>
          <a href="/ansprechpartner/">
            <img src="/src/email.png" alt="email-logo"></img>
          </a>
        </div> */}

        <div className="header-socials hide-desktop">

          <a href="https://www.instagram.com/erfolgreich.gastro/">
            <img src="/src/icons/instagram_icon.png" alt="instagram-logo"></img> 
          </a>

          <a href="https://www.facebook.com/ErfolgreichGASTRO">
            <img src="/src/icons/facebook_icon.png" alt="facebook-logo"></img>
          </a>

          <a href="https://www.linkedin.com/company/erfolgreichgastro/">
            <img src="/src/icons/linkedin_icon.png" alt="linkedin-logo"></img>
          </a>

        </div>

        <div onClick={showMobileNav} className="hide-mobile" id="menu-bar">
          <div id="bar1" className="bar"></div>
          <div id="bar2" className="bar"></div>
          <div id="bar3" className="bar"></div>
        </div>
        <div className="nav-mobile-wrap">
          <nav
            role="navigation"
            id="navigtion-mobile"
            className="primary-navigation-mobile dd-none"
          >
            <div className="flex flex-col">
              <ul className="">
                <div className="pb-3">
                  <li>
                    {" "}
                    <div className="link-arrow-wrap">
                      <Link
                        className="dropdown-text-mobile flex text-up"
                        href="/marken-und-biere"
                        >
                  
                          MARKEN & BIERE{" "}
                      </Link>{" "}
                      <div onClick={toggleDropdown} className="arrow-mobile1">
                        &lang;
                      </div>
                    </div>
                    <ul
                      className="header-dropdown-mobile1 d-none"
                      id="header-dropdown1"
                    >
                      <li>
                        <Link className="px-2" href="/hacker-pschorr">
                          Hacker-Pschorr
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/paulaner">
                          Paulaner
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/fuerstenberg">
                          Fürstenberg
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/auerbraeu">
                          Auerbräu
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/chiemseer">
                          Chiemseer
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/schmucker">
                          Schmucker
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/hoepfner">
                          Hoepfner
                        </Link>
                      </li>
                    </ul>
                  </li>
                </div>

                <div className="pb-3">
                  <li>
                    <div className="link-arrow-wrap">
                      <Link
                        className="dropdown-text-mobile flex"
                        href="/service-und-seminare"
                        >
                          SERVICE & SEMINARE{" "}
                      </Link>{" "}
                      <div onClick={toggleDropdown2} className="arrow-mobile2">
                        &lang;
                      </div>
                    </div>
                    <ul
                      className="header-dropdown-mobile d-none"
                      id="header-dropdown2"
                    >
                      <li>
                        <Link className="px-2" href="/ansprechpartner">
                          Ansprechpartner
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/unsere-seminare">
                          Seminare
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/gastronomieforum">
                          Gastronomieforum
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/stern-der-gastlichkeit">
                          Stern der Gastlichkeit
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/pachtboerse">
                          Pachtbörse
                        </Link>
                      </li>
                      <li onClick={showSubLinksMobile}>
                        <a className="px-2">Mediendatenbank</a>
                        <div
                          className="sublinks-box"
                          style={{ height: "0px" }}
                          id="subLinkBoxMobile"
                        >
                          <a
                            target="_blank"
                            href="https://www.pbg-mediendatenbank.de/hacker-de/de/login"
                            className="px-2 sub-link"
                          >
                            Hacker-Pschorr
                          </a>
                          <a
                            target="_blank"
                            href="https://www.pbg-mediendatenbank.de/paulaner-de/de/login"
                            className="px-2 sub-link"
                          >
                            Paulaner
                          </a>
                          <a
                            target="_blank"
                            href="https://www.pbg-mediendatenbank.de/chiemseer/de/login"
                            className="px-2 sub-link"
                          >
                            Chiemseer
                          </a>
                          <a
                            target="_blank"
                            href="https://www.pbg-mediendatenbank.de/hoepfner/de/login"
                            className="px-2 sub-link"
                          >
                            Hoepfner
                          </a>
                          <a
                            target="_blank"
                            href="https://www.pbg-mediendatenbank.de/schmucker/de/login"
                            className="px-2 sub-link"
                          >
                            Schmucker
                          </a>
                          <a
                            target="_blank"
                            href="https://www.pbg-mediendatenbank.de/fuerstenberg-de/de/login"
                            className="px-2 sub-link"
                          >
                            Fürstenberg
                          </a>
                          <a
                            target="_blank"
                            href="https://www.pbg-mediendatenbank.de/bilger-stuemple/de/login"
                            className="px-2 sub-link"
                          >
                            Bilger Stümple
                          </a>
                          <a
                            target="_blank"
                            href="https://www.pbg-mediendatenbank.de/riegeler/de/login"
                            className="px-2 sub-link"
                          >
                          Riegeler
                          </a>
                        </div>
                      </li>
                      <li>
                        <Link target="_blank" className="px-2" href="https://posmaterial.paulaner.de/de_DE#/?_k=scfkob">
                          Werbemittelkonfigurator
                        </Link>
                      </li>
                    </ul>
                  </li>
                </div>

                <div className="pb-16">
                  <li>
                    <div className="link-arrow-wrap">
                      <Link
                        className="dropdown-text-mobile flex"
                        href="/schanktechnik-und-bierpflege"
                        >
                          SCHANKTECHNIK & BIERPFLEGE{" "}
                      </Link>
                      <div onClick={toggleDropdown3} className="arrow-mobile3">
                        &lang;
                      </div>
                    </div>
                    <ul
                      className="header-dropdown-mobile  d-none"
                      id="header-dropdown3"
                    >
                      <li>
                        <Link className="px-2" href="/bierpflege">
                            Bierpflege
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/schanktechnik">
                            Schanktechnik
                        </Link>
                      </li>
                      <li>
                        <Link className="px-2" href="/schankdruckrechner">
                            Schankdruckrechner
                        </Link>
                      </li>
                    </ul>
                  </li>
                </div>
              </ul>
            </div>
            <div className="header-contact ">
              <a href="mailto:erfolgreichgastro@paulaner-gruppe.de ?subject=Bitte um Rückruf &body=Sehr geehrte Damen und Herren,%0D%0A%0D%0A ich bitte um einen Rückruf.%0D%0A Meine Telefonnummer ist:%0D%0A%0D%0A Mit freundlichen Grüßen">
                <img src="/src/phone.png" alt="phone-logo"></img>
              </a>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Header;